export default __webpack_public_path__ + "static/media/eight.5880828f.svg";